// extracted by mini-css-extract-plugin
export default {"isLive":"C9NXZ"};